import { z } from "zod";

const base = z.object({
  name: z.string().trim().min(1, "Name is required"),
  description: z.string().optional(),
  subject: z.string().trim().min(1, "Subject is required"),
  body: z.string().trim().min(1, "Body pattern is required"),
  status: z.string(),
});

export const mailFilterCreateSchema = base;

export const mailFilterEditSchema = base.extend({
  id: z.string().trim().min(1, "Missing record id"),
});
